(() => {
  'use strict';
  const dialog = document.getElementById('bpf-lc-console-upsell');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const root = dialog.dataset.root || '/';
  const ids = { fuse: 44818162352413, consolePanel: 47658358997277, bundle: 67915460968733 };
  const handles = ['80-series-land-cruiser-fuse-block-mount-console-molle-bundle', 'bpf-80-series-land-cruiser-fuse-block-mount', 'bpf-80-series-land-cruiser-lx450-center-console-molle-panel'];
  const accept = dialog.querySelector('[data-bpf-accept]');
  const status = dialog.querySelector('[data-bpf-status]');
  const label = accept.textContent;
  let sourceKey = null;
  let busy = false;
  let checking = false;
  let productsPromise;
  let returnFocus;
  const preview = dialog.dataset.previewAllowed === 'true' && new URLSearchParams(location.search).get('bpf_console_bundle_preview') === '1';
  const request = async (path, body) => {
    const response = await fetch(root + path, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...(body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || 'Request failed');
    return data;
  };
  const eligible = cart => {
    if (cart.items.some(item => item.variant_id === ids.bundle)) return null;
    const singles = cart.items.filter(item => item.variant_id === ids.fuse || item.variant_id === ids.consolePanel);
    return singles.length === 1 && singles[0].quantity === 1 ? singles[0] : null;
  };
  const getProducts = () => {
    if (!productsPromise) productsPromise = Promise.all(handles.map(handle => request('products/' + handle + '.js'))).catch(error => { productsPromise = null; throw error; });
    return productsPromise;
  };
  const display = (products, currency) => {
    const [bundle, fuse, consolePanel] = products;
    const variant = bundle.variants.find(item => item.id === ids.bundle);
    const fuseVariant = fuse.variants.find(item => item.id === ids.fuse);
    const consolePanelVariant = consolePanel.variants.find(item => item.id === ids.consolePanel);
    if (!variant || !fuseVariant || !consolePanelVariant || !variant.available) return false;
    const original = fuseVariant.price + consolePanelVariant.price;
    if (variant.price >= original) return false;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    dialog.querySelector('[data-bpf-original]').textContent = money(original);
    dialog.querySelector('[data-bpf-price]').textContent = money(variant.price) + ' ' + currency;
    const saving = dialog.querySelector('[data-bpf-saving]');
    saving.textContent = saving.dataset.template.replace('[amount]', money(original - variant.price));
    const image = dialog.querySelector('[data-bpf-image]');
    if (bundle.featured_image) { image.src = bundle.featured_image; image.hidden = false; }
    status.textContent = '';
    returnFocus = document.activeElement;
    dialog.showModal();
    accept.focus();
    return true;
  };
  const refresh = () => document.dispatchEvent(new CustomEvent('cart:build'));
  const finish = () => { refresh(); dialog.close(); };
  const dismiss = () => { if (!busy) dialog.close(); };
  dialog.querySelectorAll('[data-bpf-dismiss]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog || busy) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  dialog.addEventListener('close', () => { if (returnFocus?.isConnected) returnFocus.focus(); });
  const check = async event => {
    if (preview || checking || busy || dialog.open || document.querySelector('dialog[open].bpf-upsell')) return;
    const added = event?.detail?.product;
    if (added && ![ids.fuse, ids.consolePanel].includes(Number(added.variant_id || added.id))) return;
    checking = true;
    dialog.dataset.check = 'reading-cart';
    try {
      const cart = await request('cart.js');
      const single = eligible(cart);
      if (!single) { dialog.dataset.check = 'ineligible'; return; }
      dialog.dataset.check = 'loading-products';
      const products = await getProducts();
      sourceKey = single.key;
      dialog.dataset.check = display(products, cart.currency) ? 'shown' : 'unavailable';
    } catch (error) {
      sourceKey = null;
      dialog.dataset.check = 'error';
      console.warn('BPF Land Cruiser console offer:', error.message);
    } finally { checking = false; }
  };
  accept.addEventListener('click', async () => {
    if (busy || preview || !sourceKey) return;
    busy = true;
    accept.disabled = true;
    accept.textContent = accept.dataset.loading;
    status.textContent = '';
    let attemptedAdd = false;
    let attemptedRemove = false;
    try {
      const before = await request('cart.js');
      const single = eligible(before);
      if (!single || single.key !== sourceKey) { status.textContent = status.dataset.changed; return; }
      attemptedAdd = true;
      await request('cart/add.js', { items: [{ id: ids.bundle, quantity: 1 }] });
      attemptedRemove = true;
      await request('cart/change.js', { id: sourceKey, quantity: 0 });
      const after = await request('cart.js');
      if (after.items.some(item => item.key === sourceKey) || !after.items.some(item => item.variant_id === ids.bundle && item.quantity === 1)) throw new Error('Cart did not match the offer');
      finish();
    } catch (error) {
      if (attemptedAdd) {
        try {
          const current = await request('cart.js');
          const single = current.items.find(item => item.key === sourceKey);
          const pair = current.items.find(item => item.variant_id === ids.bundle);
          if (attemptedRemove && !single && pair?.quantity === 1) { finish(); return; }
          if (single && pair?.quantity === 1) await request('cart/change.js', { id: pair.key, quantity: 0 });
        } catch (recoveryError) {
          location.assign(root + 'cart');
          return;
        }
      }
      refresh();
      status.textContent = status.dataset.error;
    } finally {
      busy = false;
      accept.disabled = false;
      accept.textContent = label;
    }
  });
  document.addEventListener('ajaxProduct:added', check);
  if (document.body.classList.contains('template-cart')) check();
  if (preview) {
    const products = [
      { variants: [{ id: ids.bundle, price: 18300, available: true }], featured_image: 'https://cdn.shopify.com/s/files/1/0183/4139/files/DSC_0113.jpg?v=1777942274' },
      { variants: [{ id: ids.fuse, price: 14000 }] },
      { variants: [{ id: ids.consolePanel, price: 5900 }] }
    ];
    display(products, 'USD');
    accept.disabled = true;
    status.textContent = status.dataset.preview;
  }
})();
